/**
 * Plateforme multi evenement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.presentationVocale.ts
 *
 * Messages de la PRÉSENTATION VOCALE (2026-10-04, demande de Mika) :
 *   - le bloc d'écoute de la page d'accueil (anonyme et « Mon espace ») ;
 *   - la rubrique « Présentation vocale » de /admin/content.
 * Identité de l'événement par jetons ({eventTypeOf}...), jamais en dur : le
 * fichier, le titre et la transcription d'une instance vivent en base
 * (réglages home.voix.*, V146), pas ici.
 * Fusionné dans fr.ts.
 *
 * Mikael - chef de projet - 2026-10-04
 */
export const messagesPresentationVocaleFr: Record<string, string> = {
  // ── Bloc d'écoute, page d'accueil ──────────────────────────────────────
  'presentationVocale.titreDefaut': 'Écoutez la présentation {eventTypeOf}',
  'presentationVocale.region': 'Présentation vocale',
  'presentationVocale.ecouter': 'Écouter la présentation',
  'presentationVocale.pause': 'Mettre en pause',
  'presentationVocale.reprendre': 'Reprendre l’écoute',
  'presentationVocale.etat.lecture': 'Lecture en cours',
  'presentationVocale.etat.pause': 'Lecture en pause',
  'presentationVocale.etat.fin': 'Lecture terminée',
  'presentationVocale.etat.chargement': 'Chargement de l’audio',
  'presentationVocale.etat.erreur': 'Le fichier audio ne peut pas être lu pour le moment.',
  'presentationVocale.duree': 'Durée : {duree}',
  'presentationVocale.progression': 'Avancement de la lecture',
  'presentationVocale.progressionValeur': '{ecoule} sur {total}',
  'presentationVocale.lireTexte': 'Lire le texte',
  'presentationVocale.masquerTexte': 'Masquer le texte',
  'presentationVocale.minutes': '{min} min {sec}',
  'presentationVocale.secondes': '{sec} s',

  // ── Back-office : rubrique de /admin/content ───────────────────────────
  'presentationVocale.admin.titre': 'Présentation vocale',
  'presentationVocale.admin.aide':
    'Un fichier audio que les visiteurs écoutent depuis la page d’accueil, en appuyant sur un bouton. Jamais de lecture automatique. La transcription s’affiche sous « Lire le texte ».',
  'presentationVocale.admin.actif': 'Afficher la présentation vocale sur l’accueil',
  'presentationVocale.admin.actifAide':
    'Le bloc n’apparaît que si un fichier audio est en place.',
  'presentationVocale.admin.fichier': 'Fichier audio en place',
  'presentationVocale.admin.aucunFichier': 'Aucun fichier audio pour le moment.',
  'presentationVocale.admin.lecteur': 'Écouter le fichier audio',
  'presentationVocale.admin.deposer': 'Déposer un nouveau fichier audio',
  'presentationVocale.admin.formats': 'MP3, M4A, AAC, OGG ou WAV, 15 Mo au plus.',
  'presentationVocale.admin.envoiEnCours': 'Envoi du fichier…',
  'presentationVocale.admin.deposeAEnregistrer':
    'Nouveau fichier déposé. Écoutez-le, puis enregistrez pour le publier.',
  'presentationVocale.admin.tropGros': 'Le fichier dépasse 15 Mo.',
  'presentationVocale.admin.refuse': 'Fichier refusé : {raison}',
  'presentationVocale.admin.titreChamp': 'Titre du bloc',
  'presentationVocale.admin.titreAide': 'Vide : « {defaut} ».',
  'presentationVocale.admin.transcription': 'Transcription (texte lu par la voix)',
  'presentationVocale.admin.transcriptionAide':
    'Le texte exact de l’audio. Il rend la présentation accessible aux personnes qui ne peuvent pas l’écouter.',
  'presentationVocale.admin.dureeLue': 'Durée lue dans le fichier : {duree}',
  'presentationVocale.admin.enregistrer': 'Enregistrer la présentation vocale',
  'presentationVocale.admin.enregistre': 'Présentation vocale enregistrée.',
  'presentationVocale.admin.erreur': 'Enregistrement impossible : {raison}',
  'presentationVocale.admin.chargement': 'Chargement de la présentation vocale…',
  'presentationVocale.admin.indisponible':
    'Présentation vocale indisponible : appliquez la migration V146.',
  'presentationVocale.admin.ancienConserve':
    'L’ancien fichier reste sur le serveur : rien n’est supprimé.',
};
